<template lang='pug'>
  .logo-section
    .container
      .row
        template(v-if='isMobile')
          .nav-container.col-3.sidebar-toggle
            span#toggle-sidebar.hamburger-icon.svg-icon.menu(@click='toggleSidebar')
          .col-6.logo-container
            a(href='/?ref=logo' v-if="isSsrActivated")
            router-link(:to='{ name: "home-index", query: { ref: "logo" } }' v-else)
              img.logo-img(:class='i18nSiteCountryLs' alt='Sephora' src='../../../assets/images/icons/sephora-logo.svg')
          .nav-container.col-3
            a.user-account(:href='accountUrl')
              span.account-icon.svg-icon.account
            .top-cart.cart
              a.cart-link(:href='cartUrl')
                span.cart-bag-icon.svg-icon.bag-black
                span.count(v-show='lineItemsCount > 0' v-text='lineItemsCount')

        template(v-else)
          .logo-container.col-lg-3.col-md-5.col-sm-6.col-xs-6
            a(href='/?ref=logo' v-if="isSsrActivated")
            router-link(:to='{ name: "home-index", query: { ref: "logo" } }' v-else)
              img.logo-img(:class='i18nSiteCountryLs' alt='Sephora' src='../../../assets/images/icons/sephora-logo.svg')
          .search.col-lg-6.col-md-7.col-sm-6.col-xs-6
            search
          .banner.col-lg-3
            promotion-banner

    search(v-if='isMobile')
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import PromotionBanner from './promotion-banner.vue'
import Search from './search.vue'
import { isSsrActivated } from '@/mixins/ssrUtil'

export default {
  components: {
    PromotionBanner,
    Search
  },

  data () {
    return {
      isSsrActivated: false
    }
  },

  computed: {
    ...mapState({
      showAdminNav: state => state.layout.showAdminNav,
      currentUser: state => state.user.currentUser,
      categories: state => state.category.categories,
      cart: state => state.cart.cart
    }),
    ...mapGetters(['lineItemsCount']),
    isMobile: () => vueSupport.isMobile,
    i18nSiteCountryLs: () => I18n.siteCountryLs,
    accountUrl () {
      return this.currentUser ? '/account/dashboard' : `/users/sign_in?return_to=${this.$route.fullPath}`
    },
    cartUrl () {
      return `/cart?return_to=${this.$route.fullPath}`
    }
  },

  async created () {
    if (!this.cart && this.isMobile) {
      this.$store.dispatch('getLineItemsCount')
    }

    this.ssrActivated = await isSsrActivated()
  },

  methods: {
    toggleSidebar () {
      // renderSidebar determines whether the sidebar is rendered, independent of whether or not its shown to the user
      this.$store.commit('setRenderSidebar', true)
      this.$store.commit('setShowSidebar', true)
      this.$store.commit('setFocusSearch', false)
    }
  }
}
</script>

<style lang='scss' scoped>
  .row {
    @include media-breakpoint-up(sm) {
      max-height: initial;
      margin: 0;
    }
  }

  .banner {
    display: flex;
    justify-content: flex-end;

    @include media-breakpoint-up(lg) {
      padding: 0;
    }
  }

  .search {
    margin: auto;
  }

  .logo {
    display: block;
    height: 100%;
  }

  .logo-img {
    vertical-align: bottom;
    width: 100%;
    height: 100%;
  }

  .logo-container {
    @include media-breakpoint-down(sm) {
      margin-top: 6px;
      margin-bottom: 7px;
    }
  }

  .cart-bag-icon {
    width: 28px;
    height: 100%;
    background-size: 28px 28px;
    vertical-align: bottom;
  }

  .account-icon {
    width: 27px;
    height: 100%;
    background-size: 27px 27px;
    vertical-align: bottom;
  }

  .hamburger-icon {
    width: 28px;
    height: 100%;
    background-size: 28px 28px;
  }

  .nav-container {
    display: flex;
    justify-content: space-between;
  }

  .logo-section {
    margin-top: 25px;
    margin-bottom: 10px;

    @include media-breakpoint-down(sm) {
      transition: height 0.5s;
      padding-top: 5px;
      margin: 0;
      box-sizing: border-box;

      .icon {
        margin-left: 10px;
        margin-right: 10px;
      }

      .top-cart {
        text-align: left;

        .count {
          width: 12px;
          height: 6px;
          padding: 4px 1px;
          border-radius: 12px;
          position: absolute;
          z-index: 10;
          font-size: 10px;
          text-align: center;
          line-height: 8px;
          color: $white;
          display: block;
          top: 1px;
          right: 12px;
          background: $brand-primary;
          box-sizing: content-box;
        }
      }

      .sidebar-toggle {
        padding-left: 5px;
      }

      .cart {
        padding-right: 5px;
      }

      .cart-link {
        display: block;
        height: 100%;
      }
    }
  }
</style>
